import axios from "axios";
import React, { useEffect, useReducer, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import { Tooltip } from 'react-tooltip'
import { BsFillInfoCircleFill } from "react-icons/bs";
import Autosuggest from 'react-autosuggest';

import TextField from "@mui/material/TextField";

import Loading from "./components/Loading";
import "../css/style.css"

const Home = () => {
    const [orderId, setOrderId] = useState("");
    const [eventId, setEventId] = useState("");
    const [loading, setLoading] = useState(true);
    const [isAlreadyAlltronCustomer, setIsAlreadyAlltronCustomer] = useState(false);
    const [isAlreadyBrackCustomer, setIsAlreadyBrackCustomer] = useState(false);
    const [isNotCustomer, setIsNotCustomer] = useState(false);
    const [user, setUser] = useState({
        salutation: "",
        firstname: "",
        lastname: "",
        company: "",
        function: "",
        street: "",
        place: "",
        city: "",
        country: "176",
        phone: "",
        email: "",
        confirmemail: "",
        tickettypeid: "",
        customernumber: "",
    });

    // react hook for navigation
    let navigate = useNavigate();

    // base url
    let baseUrl = process.env.REACT_APP_BASEURL_API;

    // fetching resources
    const [resources, setResources] = useState({});

    const { language } = useParams();

    useEffect(() => {
        loadToken();
    }, []); //only on first page load

    const loadToken = () => {
        axios.get("form/token").then((res) => {
            axios.defaults.headers.common["Authorization"] = "Bearer " + res.data;

            sessionStorage.setItem("token", res.data);

            requestFormSettings();
        });
    };

    const requestFormSettings = () => {
        axios.get(`form/formsettings`).then((res) => {
            startOrder(res.data.posId, res.data.eventId);
            setEventId(res.data.eventId);
        });
    };

    useEffect(() => {
        requestResources();
    }, [language]); //everytime language is changed

    const requestResources = () => {
        axios
            .get(`form/resources/${language}`)
            .then((res) => {
                setResources(res.data);
            })
            .catch((error) => console.error(error.response.data));
    };

    const startOrder = (posId, eventId) => {
        let order = {
            affiliateShopId: null,
            currency: "CHF",
            tenantId: 1,
            pointOfSaleId: posId,
            abbreviation: "",
            paymentType: 1,
        };

        axios
            .post(`${baseUrl}/ShopBasket/Order`, order)
            .then((res) => {
                sessionStorage.setItem("OrderId", res.data.id);

                setOrderId(res.data.id);
                setLoading(true);

                setTimeout(() => setLoading(false), 500);
            })
            .catch((error) => console.error(error.response.data));
    };

    const onSubmit = async () => {
        await addAddressToBasket();
    };

    const getCustomerType = () => {
        let customerType = resources?.translation.HomeCustomerTypeNoCustomer;
        let customerTypeShortned = resources?.translation.HomeCustomerTypeNoCustomerShortned;

        if (isAlreadyAlltronCustomer) {
            customerType = resources?.translation.HomeCustomerTypeAlltron;
            customerTypeShortned = resources?.translation.HomeCustomerTypeAlltronShortned;
        } else if (isAlreadyBrackCustomer) {
            customerType = resources?.translation.HomeCustomerTypeBrack;
            customerTypeShortned = resources?.translation.HomeCustomerTypeBrackShortned;
        }

        return { customerType, customerTypeShortned };
    };

    const addAddressToBasket = async () => {

        const { customerType, customerTypeShortned } = getCustomerType();

        let addressBody = {
            salutation: user.salutation,
            firstname: user.firstname,
            name: user.lastname,
            function: user.function,
            company: user.company,
            street: user.street,
            postCode: user.place,
            city: user.city,
            telephone: user.phone,
            countryId: user.country,
            email: user.email,
            code1: user.customernumber,
            code3: customerType,
            code4: customerTypeShortned
        };

        await axios
            .put(`${baseUrl}/Order/${orderId}/Address`, addressBody)
            .then(() => addTicketToBasket())
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const addTicketToBasket = async () => {

        const { customerType, customerTypeShortned } = getCustomerType();

        let addTicketTypes = [];

        // check if its both days
        if (user.tickettypeid.includes("_")) {
            const ticketTypeIds = user.tickettypeid.split("_");
            const ticketTypeId1 = ticketTypeIds[0];
            const ticketTypeId2 = ticketTypeIds[1];

            addTicketTypes = [{ ticketTypeId: ticketTypeId1, quantity: 1, option4: customerTypeShortned }, { ticketTypeId: ticketTypeId2, quantity: 1, option4: customerTypeShortned }];
        } else {
            addTicketTypes = [{ ticketTypeId: user.tickettypeid, quantity: 1, option4: customerTypeShortned }];
        }

        await axios
            .post(`${baseUrl}/ShopBasket/Order/${orderId}/Tickets`, {
                ticketsToAdd: addTicketTypes,
            })
            .then(async () => {
                const response = await confirmShopbasketByOrderId(orderId);
                if (response) {
                    //navigate(`/${language}/confirmation/${orderId}`);
                    window.location.href = `/${language}/confirmation/${orderId}`;
                }
            })
            .catch((error) => {
                console.error(error.response.data);
            });
    };

    const confirmShopbasketByOrderId = async (orderId) => {
        try {
            const res = await axios.put(`${baseUrl}/ShopBasket/Order/${orderId}/Confirm`);
            return res.data;
        } catch (error) {
            console.error(error)
        }
    };

    const onCheckedChange = (e) => {
        if (e.target.value.includes(resources.translation._Mr)) {
            setUser({ ...user, ["salutation"]: resources.translation._Mr });
        }

        if (e.target.value.includes(resources.translation._Mrs)) {
            setUser({ ...user, ["salutation"]: resources.translation._Mrs });
        }

        if (e.target.value.includes(resources.translation._Divers)) {
            setUser({ ...user, ["salutation"]: resources.translation._Divers });
        }
    }

    const onIsAlreadyCustomerChange = (e) => {
        if (e.target.value.includes("trueAlltron")) {
            setIsAlreadyAlltronCustomer(true);
        } else if (e.target.value.includes("trueBrack")) {
            setIsAlreadyBrackCustomer(true);
        } else {
            setIsNotCustomer(true);
            setIsAlreadyAlltronCustomer(false);
            setIsAlreadyBrackCustomer(false);
            setUser({ ...user, customernumber: "" });
        }
    }

    const onInputChange = (e) => {
        setUser({ ...user, [e.target.name]: e.target.value });
    };

    // autosuggestion for personfunktion
    const personFunctions = [
        { name: 'Abteilungsleiter*in' },
        { name: 'Account Manager*in' },
        { name: 'Administration' },
        { name: 'Backoffice' },
        { name: 'Buchhaltung' },
        { name: 'Business Development' },
        { name: 'Category Manager*in' },
        { name: 'CEO' },
        { name: 'CFO' },
        { name: 'CIO' },
        { name: 'CMO' },
        { name: 'Consultant' },
        { name: 'COO' },
        { name: 'CSO' },
        { name: 'CTO' },
        { name: 'Digital Marketing Manager*in' },
        { name: 'Einkauf' },
        { name: 'Geschäftsführer*in' },
        { name: 'Geschäftsleitung' },
        { name: 'Head of IT' },
        { name: 'Head of Marketing' },
        { name: 'Head of Sales' },
        { name: 'ICT-Support' },
        { name: 'IT-Support' },
        { name: 'Marketingleiter*in' },
        { name: 'Marketingmanager*in' },
        { name: 'Product Manager*in' },
        { name: 'Projektleiter*in' },
        { name: 'Projektleiter*in ICT' },
        { name: 'Projektleiter*in IT' },
        { name: 'Projektleiter*in Marketing' },
        { name: 'Sales Consultant' },
        { name: 'Sales Manager*in' },
        { name: 'Senior Account Manager' },
        { name: 'Senior Consultant' },
        { name: 'Senior Projektleiter*in' },
        { name: 'Strategischer Einkauf' },
        { name: 'Stv. Geschäftsführer*in' },
        { name: 'Support' },
        { name: 'System Engineer*in' },
        { name: 'Systemtechniker*in' },
        { name: 'Technik' },
        { name: 'Telekom' },
        { name: 'Telematiker*in' },
        { name: 'Verkauf' },
        { name: 'Verkaufsleiter*in' },
        { name: 'Vertriebsleiter*in' },
        { name: 'Verwaltungsrat' }
    ];

    // validating input fields
    let validation =
        /^([a-z A-Zöéàäèü]{1,70})$/.test(user.salutation) &&
        /^.{1,70}$/.test(user.firstname) &&
        /^.{1,70}$/.test(user.lastname) &&
        /^.{1,70}$/.test(user.company) &&
        /^.{1,70}$/.test(user.function) &&
        /^.{1,70}$/.test(user.street) &&
        /^.{1,70}$/.test(user.place) &&
        /^.{1,70}$/.test(user.city) &&
        /^.{1,70}$/.test(user.phone) &&
        /^.{1,70}$/.test(user.tickettypeid) &&
        /^([a-z A-Zöéàäèü 0-9 - ]{1,70})$/.test(user.country) &&
        /^\S+@\S+\.\S+$/.test(user.email) &&
        /^\S+@\S+\.\S+$/.test(user.confirmemail) &&
        user.email === user.confirmemail;

    if (!isAlreadyAlltronCustomer && !isAlreadyBrackCustomer && !isNotCustomer) validation = false;

    if ((isAlreadyAlltronCustomer || isAlreadyBrackCustomer) && user.customernumber === "") validation = false;

    ////check if autosuggestion selection is valid
    //if (!personFunctions.some(personFunction => user.function.includes(personFunction.name))) validation = false;

    // autosuggestion for personfunktion
    const [value, setValue] = useState('');
    const [suggestions, setSuggestions] = useState([]);

    const getSuggestions = (inputValue) => {
        const inputValueLowerCase = inputValue.toLowerCase();
        return personFunctions.filter((lang) =>
            lang.name.toLowerCase().startsWith(inputValueLowerCase)
        );
    };

    const onSuggestionsFetchRequested = ({ value }) => {
        setSuggestions(getSuggestions(value));
    };

    const onSuggestionsClearRequested = () => {
        setSuggestions([]);
    };

    const onChange = (event, { newValue }) => {
        setValue(newValue);
        setUser({ ...user, function: newValue });
    };

    const getSuggestionValue = (suggestion) => suggestion.name;

    const renderSuggestion = (suggestion) => (
        <div className="react-autosuggest-div" role="button">
            {suggestion.name}
        </div>
    );

    const renderInputComponent = (inputProps) => {
        const { ref, ...other } = inputProps;

        return (
            <TextField
                variant="standard"
                fullWidth
                margin="normal"
                label="Funktion*"
                inputRef={ref}
                {...other}
            />
        );
    };

    const inputProps = {
        placeholder: '',
        value,
        onChange: onChange
    };

    return (
        <div>
            {/* loop the ticket types */}
            {loading ? (
                <>
                    <div className="d-none d-lg-block">
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="#fff"
                            position="fixed"
                            top="50%"
                            left="50%"
                        />
                    </div>
                    <div className="d-lg-none">
                        <Loading
                            alignment="center"
                            color="#d3d3d3"
                            bgColor="#fff"
                            position="fixed"
                            top="45%"
                            left="45%"
                        />
                    </div>
                </>
            ) : (
                <>
                    {resources.translation && (
                        <div className="container wrapper ps-0 pe-0">
                            <div className="mt-3 mb-3">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="title">
                                            <span>{resources.translation.Title}</span>
                                        </div>
                                    </div>
                                </div>

                                <div className="box mt-4">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="subtitle">
                                                <span>{resources.translation.Subtitle}</span>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-4">
                                        <div className="col-md-12">
                                            <select
                                                className="form-control custom-dropdown"
                                                name="tickettypeid"
                                                value={user.tickettypeid}
                                                onChange={(e) => onInputChange(e)}>
                                                <option value="">{resources.translation.HomePleaseChoose}</option>
                                                <option disabled="disabled">---------------------------------------------------------</option>
                                                <option value="824236">{resources.translation.HomeFirstDay}</option>
                                                <option value="824237">{resources.translation.HomeSecondDay}</option>
                                                <option value="824236_824237">{resources.translation.HomeBothDays}</option>
                                            </select>
                                        </div>
                                    </div>
                                </div>


                                <div className="row mt-4">
                                    <div className="col-md-12">
                                        <p className="fw-bold">Bitte folgende Hinweise beachten:</p>
                                        <ul>
                                            <li>Alle Besucherinnen und Besucher benötigen ein persönliches Ticket.</li>
                                            <li>Pro Bestellung ist nur ein Ticket möglich (für einen oder für beide Messetag(e)).</li>
                                        </ul>
                                    </div>
                                </div>


                                {/* user data */}
                                <div className="box">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <span className="fw-bold">Dein Kundenstatus:</span><span className="red">*</span>
                                        </div>

                                        <div className="col-md-12 mt-3">
                                            <div className="d-flex align-items-start">
                                                <input
                                                    id="YesCustomerAlltron"
                                                    type="radio"
                                                    name="customerstatus"
                                                    value="trueAlltron"
                                                    onChange={(e) => onIsAlreadyCustomerChange(e)}
                                                    required
                                                    className="mt-2 me-2"
                                                    style={{ width: '0.8em', height: '0.8em' }}
                                                />
                                                <label htmlFor="YesCustomerAlltron">
                                                    {resources?.translation.HomeCustomerTypeAlltron}
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-md-12 mt-2">
                                            <div className="d-flex align-items-start">
                                                <input
                                                    id="YesCustomerBrack"
                                                    type="radio"
                                                    name="customerstatus"
                                                    value="trueBrack"
                                                    onChange={(e) => onIsAlreadyCustomerChange(e)}
                                                    required
                                                    className="mt-2 me-2"
                                                    style={{ width: '0.8em', height: '0.8em' }}
                                                />
                                                <label htmlFor="YesCustomerBrack">
                                                    {resources?.translation.HomeCustomerTypeBrack}
                                                </label>
                                            </div>
                                        </div>

                                        <div className="col-md-12 mt-2">
                                            <div className="d-flex align-items-start">
                                                <input
                                                    id="notCustomer"
                                                    type="radio"
                                                    name="customerstatus"
                                                    value="false"
                                                    onChange={(e) => onIsAlreadyCustomerChange(e)}
                                                    required
                                                    className="mt-2 me-2"
                                                    style={{ width: '0.8em', height: '0.8em' }}
                                                />
                                                <label htmlFor="notCustomer">
                                                    {resources?.translation.HomeCustomerTypeNoCustomer}
                                                </label>
                                            </div>
                                        </div>
                                    </div>

                                    <div className="row mt-3">
                                        <div className="col-md-12 mt-3">
                                            <span className="fw-bold">Bitte gebe nachfolgend deine Daten ein:</span>
                                        </div>
                                    </div>

                                    <div className="row mt-2">
                                        <div className="col-md-2 mt-3">
                                            <span>Anrede*</span>
                                        </div>
                                    </div>

                                    <div className="row">
                                        <div className="col-md-12 mt-3 d-flex flex-wrap align-items-center">
                                            <div className="d-flex align-items-center me-4">
                                                <input
                                                    id="mr"
                                                    type="radio"
                                                    name="salutation"
                                                    value={resources.translation._Mr}
                                                    onChange={(e) => onCheckedChange(e)}
                                                    required
                                                    style={{ width: '0.8em', height: '0.8em' }}
                                                />
                                                <label htmlFor="mr" className="ms-2 f-22px">Herr</label>
                                            </div>

                                            <div className="d-flex align-items-center me-4">
                                                <input
                                                    id="mrs"
                                                    type="radio"
                                                    name="salutation"
                                                    value={resources.translation._Mrs}
                                                    onChange={(e) => onCheckedChange(e)}
                                                    required
                                                    style={{ width: '0.8em', height: '0.8em' }}
                                                />
                                                <label htmlFor="mrs" className="ms-2 f-22px">Frau</label>
                                            </div>

                                            <div className="d-flex align-items-center">
                                                <input
                                                    id="divers"
                                                    type="radio"
                                                    name="salutation"
                                                    value={resources.translation._Divers}
                                                    onChange={(e) => onCheckedChange(e)}
                                                    required
                                                    style={{ width: '0.8em', height: '0.8em' }}
                                                />
                                                <label htmlFor="divers" className="ms-2 f-22px">Divers</label>
                                            </div>
                                        </div>
                                    </div>

                                    <TextField
                                        name="firstname"
                                        label="Vorname*"
                                        variant="standard"
                                        fullWidth
                                        margin="normal"
                                        color="#191919"
                                            sx={{
                                                "& .MuiInput-underline:before": {
                                                    borderBottom: "1px solid #191919", // fixed border
                                                },
                                                "& .MuiInput-underline:hover:before": {
                                                    borderBottom: "1px solid #191919 !important", // no change on hover
                                                },
                                                "& .MuiInput-underline:after": {
                                                    borderBottom: "none", // remove animated underline
                                                },
                                                "& .MuiInputBase-input": {
                                                    boxShadow: "none", // no focus outline shifting
                                                }
                                            }}
                                        value={user.firstname}
                                        onChange={(e) => onInputChange(e)}
                                    />

                                    <TextField
                                        name="lastname"
                                        label="Nachname*"
                                        variant="standard"
                                        fullWidth
                                        margin="normal"
                                        color="#191919"
                                            sx={{
                                                "& .MuiInput-underline:before": {
                                                    borderBottom: "1px solid #191919", // fixed border
                                                },
                                                "& .MuiInput-underline:hover:before": {
                                                    borderBottom: "1px solid #191919 !important", // no change on hover
                                                },
                                                "& .MuiInput-underline:after": {
                                                    borderBottom: "none", // remove animated underline
                                                },
                                                "& .MuiInputBase-input": {
                                                    boxShadow: "none", // no focus outline shifting
                                                }
                                            }}
                                        value={user.lastname}
                                        onChange={(e) => onInputChange(e)}
                                    />

                                    <Autosuggest
                                        suggestions={suggestions}
                                        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                                        onSuggestionsClearRequested={onSuggestionsClearRequested}
                                        getSuggestionValue={getSuggestionValue}
                                        renderSuggestion={renderSuggestion}
                                        inputProps={inputProps}
                                        renderInputComponent={renderInputComponent}
                                    />

                                    <TextField
                                        name="company"
                                        label="Firma*"
                                        variant="standard"
                                        fullWidth
                                        margin="normal"
                                        color="#191919"
                                            sx={{
                                                "& .MuiInput-underline:before": {
                                                    borderBottom: "1px solid #191919", // fixed border
                                                },
                                                "& .MuiInput-underline:hover:before": {
                                                    borderBottom: "1px solid #191919 !important", // no change on hover
                                                },
                                                "& .MuiInput-underline:after": {
                                                    borderBottom: "none", // remove animated underline
                                                },
                                                "& .MuiInputBase-input": {
                                                    boxShadow: "none", // no focus outline shifting
                                                }
                                            }}
                                        value={user.company}
                                        onChange={(e) => onInputChange(e)}
                                    />


                                    {(isAlreadyAlltronCustomer || isAlreadyBrackCustomer) &&
                                        <>
                                            <div className="row">
                                                <div className="col-10 col-md-4">
                                                    <TextField
                                                        name="customernumber"
                                                        label="Kundennummer*"
                                                        variant="standard"
                                                        fullWidth
                                                        margin="normal"
                                                        color="#191919"
                                                        value={user.customernumber}
                                                        onChange={(e) => onInputChange(e)}
                                                    />
                                                </div>
                                                <div className="col-1 d-flex align-items-center">
                                                    <span
                                                        data-tooltip-id="my-tooltip"
                                                        data-tooltip-html="Ihre Kundennummer finden sie in eingeloggtem<br/>Zustand in Ihrem Onlineshop-Konto oder auch<br/>auf ihrer letzten Bestellung/Rechnung."
                                                        data-tooltip-place="top">
                                                        <BsFillInfoCircleFill />
                                                    </span>
                                                    <Tooltip id="my-tooltip" />
                                                </div>
                                            </div>
                                        </>
                                    }

                                    <TextField
                                        name="street"
                                        label="Strasse*"
                                        variant="standard"
                                        fullWidth
                                        margin="normal"
                                        color="#191919"
                                            sx={{
                                                "& .MuiInput-underline:before": {
                                                    borderBottom: "1px solid #191919", // fixed border
                                                },
                                                "& .MuiInput-underline:hover:before": {
                                                    borderBottom: "1px solid #191919 !important", // no change on hover
                                                },
                                                "& .MuiInput-underline:after": {
                                                    borderBottom: "none", // remove animated underline
                                                },
                                                "& .MuiInputBase-input": {
                                                    boxShadow: "none", // no focus outline shifting
                                                }
                                            }}
                                        value={user.street}
                                        onChange={(e) => onInputChange(e)}
                                    />

                                    <div className="row">
                                        <div className="col-md-4">
                                            <TextField
                                                name="place"
                                                label="PLZ*"
                                                variant="standard"
                                                fullWidth
                                                margin="normal"
                                                color="#191919"
                                                    sx={{
                                                        "& .MuiInput-underline:before": {
                                                            borderBottom: "1px solid #191919", // fixed border
                                                        },
                                                        "& .MuiInput-underline:hover:before": {
                                                            borderBottom: "1px solid #191919 !important", // no change on hover
                                                        },
                                                        "& .MuiInput-underline:after": {
                                                            borderBottom: "none", // remove animated underline
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            boxShadow: "none", // no focus outline shifting
                                                        }
                                                    }}
                                                value={user.place}
                                                onChange={(e) => onInputChange(e)}
                                            />
                                        </div>
                                        <div className="col-md-8">
                                            <TextField
                                                name="city"
                                                label="Ort*"
                                                variant="standard"
                                                fullWidth
                                                margin="normal"
                                                color="#191919"
                                                    sx={{
                                                        "& .MuiInput-underline:before": {
                                                            borderBottom: "1px solid #191919", // fixed border
                                                        },
                                                        "& .MuiInput-underline:hover:before": {
                                                            borderBottom: "1px solid #191919 !important", // no change on hover
                                                        },
                                                        "& .MuiInput-underline:after": {
                                                            borderBottom: "none", // remove animated underline
                                                        },
                                                        "& .MuiInputBase-input": {
                                                            boxShadow: "none", // no focus outline shifting
                                                        }
                                                    }}
                                                value={user.city}
                                                onChange={(e) => onInputChange(e)}
                                            />
                                        </div>
                                    </div>

                                    <TextField
                                        name="phone"
                                        label="Telefon*"
                                        variant="standard"
                                        fullWidth
                                        margin="normal"
                                        color="#191919"
                                            sx={{
                                                "& .MuiInput-underline:before": {
                                                    borderBottom: "1px solid #191919", // fixed border
                                                },
                                                "& .MuiInput-underline:hover:before": {
                                                    borderBottom: "1px solid #191919 !important", // no change on hover
                                                },
                                                "& .MuiInput-underline:after": {
                                                    borderBottom: "none", // remove animated underline
                                                },
                                                "& .MuiInputBase-input": {
                                                    boxShadow: "none", // no focus outline shifting
                                                }
                                            }}
                                        value={user.phone}
                                        onChange={(e) => onInputChange(e)}
                                    />

                                    <TextField
                                        name="email"
                                        label="E-Mail*"
                                        variant="standard"
                                        fullWidth
                                        margin="normal"
                                        color="#191919"
                                            sx={{
                                                "& .MuiInput-underline:before": {
                                                    borderBottom: "1px solid #191919", // fixed border
                                                },
                                                "& .MuiInput-underline:hover:before": {
                                                    borderBottom: "1px solid #191919 !important", // no change on hover
                                                },
                                                "& .MuiInput-underline:after": {
                                                    borderBottom: "none", // remove animated underline
                                                },
                                                "& .MuiInputBase-input": {
                                                    boxShadow: "none", // no focus outline shifting
                                                }
                                            }}
                                        value={user.email}
                                        onChange={(e) => onInputChange(e)}
                                    />

                                    <TextField
                                        name="confirmemail"
                                        label={`${resources.translation.HomeEmailConfirmation}*`}
                                        variant="standard"
                                        fullWidth
                                        margin="normal"
                                        color="#191919"
                                            sx={{
                                                "& .MuiInput-underline:before": {
                                                    borderBottom: "1px solid #191919", // fixed border
                                                },
                                                "& .MuiInput-underline:hover:before": {
                                                    borderBottom: "1px solid #191919 !important", // no change on hover
                                                },
                                                "& .MuiInput-underline:after": {
                                                    borderBottom: "none", // remove animated underline
                                                },
                                                "& .MuiInputBase-input": {
                                                    boxShadow: "none", // no focus outline shifting
                                                }
                                            }}
                                        value={user.confirmemail}
                                        onChange={(e) => onInputChange(e)}
                                    />


                                    <div className="row mt-4">
                                        <div className="col-md-12">
                                            <span>* Bitte fülle die Pflichtfelder aus.</span>
                                        </div>
                                    </div>

                                    {/* button confirm */}

                                    <div className="row mt-4">
                                        <div className="col-md-6">
                                            <button
                                                className="custom-button"
                                                onClick={onSubmit}
                                                disabled={!validation}
                                            >
                                                {resources.translation.HomeNext}
                                            </button>
                                        </div>
                                    </div>
                                </div>



                            </div>
                            <p className="mt-5 text-center">
                                {resources.translation && (
                                    <small style={{ color: 'grey', fontSize: '11px' }}>powered by <a style={{ color: 'grey' }} href={resources.translation._TicketinoOrganizerUrl} target="_blank">TICKETINO</a></small>
                                )}
                            </p>
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default Home;
